import BurgerMenu from "../../assets/icons/BurgerMenu";
import CartIcon from "../../assets/icons/CartWithBadge/Cart";
import CrossIcon from "../../assets/icons/CrossIcon";
import MagazineIcon from "../../assets/icons/Magazine";
import ProfileIcon from "../../assets/icons/Profile";
import SearchIcon from "../../assets/icons/Search";
import { useRightPanel } from "../../context/RightPanelContext";
import { useAuthModal } from "../../hooks/authContext";
import useWindowSize from "../../hooks/useWindowSize";
import {
  countQuantityCart,
  getCartFromSession,
  updateShoppingCart,
} from "../../services/cartShoppingService";
import { getCategories } from "../../services/productService";
import { AppDispatch, RootState } from "../../store/store";
import RightPanel from "../RightPanel/RightPanel";
import CardItemSearch from "../SearchBar/CardItemSearch/CardItemSearch";
import SearchBar from "../SearchBar/SearchBar";
import "./Header.scss";
import MobileMenu from "./components/MobileMenu";
import axios from "axios";
import debounce from "lodash.debounce";
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const searchProducts = async (query: string) => {
  try {
    const response = await axios.get(`${API_URL}/products/search`, {
      params: {
        q: query,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la recherche :", error);
    throw error;
  }
};

const BlockCategory = ({
  categories,
  navigate,
  setShowMenu,
}: {
  categories: any[];
  navigate: NavigateFunction;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <React.Fragment>
      {categories.map((category, index) => (
        <div key={`block-category-${index}`}>
          <h3 className="category-title">{category.name}</h3>
          <div>
            {category.subcategories.map((subcategory: any, idx: number) => (
              <div
                key={`block-category-subcategory-${idx}`}
                className="subcategory-item"
                onClick={() => {
                  setShowMenu(false);
                  navigate(
                    `/category-product/${category.code}/${subcategory.code}`
                  );
                }}
              >
                {subcategory.name}
              </div>
            ))}
          </div>
        </div>
      ))}
    </React.Fragment>
  );
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const [showMenu, setShowMenu] = useState(false);
  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { categories } = useSelector((state: RootState) => state.products);
  const { shoppingCart } = useSelector((state: RootState) => state.cart);
  const { setIsOpen } = useAuthModal();
  const { isOpen: showCart, togglePanel } = useRightPanel();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [productSearch, setProductSearch] = useState([]);
  const [activeSearch, setActiveSearch] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");

  const handleQuery = debounce(async (query: string) => {
    if (query.length >= 3) {
      setActiveSearch(true);
      try {
        const results = await searchProducts(query);
        setProductSearch(results);
      } catch (err) {
        console.error(err);
      }
    } else {
      setActiveSearch(false);
    }
  }, 500);

  const goToProductSearch = ({
    categoryCode,
    subCategoryCode,
    code,
  }: {
    categoryCode?: string;
    subCategoryCode?: string;
    code?: string;
  }) => {
    navigate(`/category-product/${categoryCode}/${subCategoryCode}/${code}`, {
      replace: true,
    });
  };

  const onSearch = (query: string) => {
    setSearchInputValue(query);
    handleQuery(query);
  };

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    setSearchInputValue("");
    setActiveSearch(false);
    setIsOpenSearch(false);
  }, [location.pathname]);

  useEffect(() => {
    const savedCart = getCartFromSession();
    if (savedCart && shoppingCart && savedCart.length !== shoppingCart.length) {
      dispatch(updateShoppingCart(savedCart));
    }
  }, [dispatch, shoppingCart, shoppingCart?.length]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://sp-hygiene-pdf.s3.eu-west-3.amazonaws.com/SP-HYGIENE-Catalogue-2025.pdf";
    link.download = "Catalogue_SP_Hygiene.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <RightPanel show={showCart} />
      <div className="header">
        <div id="logo-div">
          <img
            src="/logo-sphygiene.jpeg"
            alt="logo"
            className="clickable"
            onClick={() => navigate("/")}
          />
        </div>
        <div id="list-header">
          <div
            className={
              location?.pathname.includes("/category-product") ? "active" : ""
            }
            onMouseEnter={() => setShowMenu(true)}
            onMouseLeave={() => setShowMenu(false)}
          >
            <p>PRODUITS</p>
            {showMenu && (
              <div
                className="menu-products"
                onMouseEnter={() => setShowMenu(true)}
              >
                <div className="menu-column">
                  <BlockCategory
                    categories={[
                      ...categories.slice(0, 2),
                      ...categories.filter(
                        (c) => c.name === "SEAUX & CHARIOTS"
                      ),
                    ]}
                    navigate={navigate}
                    setShowMenu={setShowMenu}
                  />
                </div>
                <div className="menu-column">
                  <BlockCategory
                    categories={categories.slice(3, 4)}
                    navigate={navigate}
                    setShowMenu={setShowMenu}
                  />
                </div>
                <div className="menu-column">
                  <BlockCategory
                    categories={categories.slice(4, 5)}
                    navigate={navigate}
                    setShowMenu={setShowMenu}
                  />
                </div>
                <div className="menu-column">
                  <BlockCategory
                    categories={[
                      ...categories.slice(7, 8),
                      ...categories.filter((c) => c.name.includes("CHR")),
                    ]}
                    navigate={navigate}
                    setShowMenu={setShowMenu}
                  />
                </div>
                <div className="menu-column">
                  <BlockCategory
                    categories={[
                      ...categories.slice(8, 9),
                      ...categories.filter((c) => c.name === "MATERIEL"),
                    ]}
                    navigate={navigate}
                    setShowMenu={setShowMenu}
                  />
                </div>
              </div>
            )}
          </div>
          <div>|</div>
          <div
            className={location?.pathname.includes("/about") ? "active" : ""}
            onClick={() => navigate("/about")}
          >
            <p>A PROPOS</p>
          </div>
          <div>|</div>
          <div
            className={
              location?.pathname.includes("/commitment") ? "active" : ""
            }
            onClick={() => navigate("/commitment")}
          >
            <p>ENGAGEMENT</p>
          </div>
          <div>|</div>
          <div
            className={location?.pathname.includes("/contact") ? "active" : ""}
            onClick={() => navigate("/contact")}
          >
            <p>CONTACT</p>
          </div>
        </div>
        <div id="list-icon">
          {isOpenSearch ? (
            <div className="search-header-bar">
              <SearchBar
                onSearch={onSearch}
                onClose={() => setIsOpenSearch(false)}
              />
            </div>
          ) : (
            <SearchIcon onClick={() => setIsOpenSearch(true)} />
          )}
          <MagazineIcon onClick={handleDownload} />
          <CartIcon
            onClick={() => togglePanel()}
            count={countQuantityCart(shoppingCart)}
          />
          <ProfileIcon
            onClick={() => {
              if (isAuthenticated) {
                navigate("/profile?informations");
              } else {
                showMenu && setShowMenu(false);
                showMenuMobile && setShowMenuMobile(false);
                setIsOpen(true);
              }
            }}
          />
          {width < 1051 &&
            (showMenuMobile ? (
              <CrossIcon onClick={() => setShowMenuMobile(false)} />
            ) : (
              <BurgerMenu onClick={() => setShowMenuMobile(true)} />
            ))}
        </div>
      </div>
      <div id="header-background" />
      {activeSearch && (
        <div className="result-search">
          <h3>Résultat de recherche "{searchInputValue}"</h3>
          {productSearch?.length > 0 &&
            productSearch.map((product) => (
              <CardItemSearch product={product} goTo={goToProductSearch} />
            ))}
        </div>
      )}
      {showMenuMobile && width < 1051 && (
        <MobileMenu
          categories={categories}
          setShowMenuMobile={setShowMenuMobile}
          headerItems={[
            { name: "PRODUITS" },
            { name: "A PROPOS", onClick: () => navigate("/about") },
            { name: "ENGAGEMENT", onClick: () => navigate("/commitment") },
            { name: "CONTACT", onClick: () => navigate("/contact") },
          ]}
        />
      )}
    </div>
  );
};

export default Header;
